import { type Commands } from '../../../core/context/commands';
import { UUID } from '../../../core/context/uuid/entity';
import { ThreatPaths } from './repository';
import { ThreatPath } from './entity';
import { type ThreatPathData } from './dto';

export class ThreatPathsCommands
    implements Commands<ThreatPaths, ThreatPath, ThreatPathData>
{
    addAll(repo: ThreatPaths, data: ThreatPathData[]): ThreatPaths {
        data.forEach((threatPathData) => {
            this.add(repo, threatPathData);
        });
        return repo;
    }

    add(repo: ThreatPaths, data: ThreatPathData): ThreatPaths {
        const threatPath = new ThreatPath({ ...data });
        repo.add(threatPath);
        return repo;
    }

    update(repo: ThreatPaths, entity: ThreatPath): ThreatPath {
        repo.update(entity);
        return entity;
    }

    remove(repo: ThreatPaths, id: string): void {
        repo.remove(id);
    }

    create(repo: ThreatPaths, data: Omit<ThreatPathData, 'id'>): ThreatPath {
        const uuid = new UUID();
        const threatPath = new ThreatPath({ id: uuid.toString(), ...data });
        repo.add(threatPath);
        return threatPath;
    }

    fromJSON(entity: ThreatPath[], changeCallback: () => void): ThreatPaths {
        const newThreatPaths = new ThreatPaths(changeCallback);
        entity.forEach((threatPath) => {
            newThreatPaths.add(new ThreatPath({ ...threatPath }));
        });
        return newThreatPaths;
    }
}
